import { Lookup } from './lookup.interface';
export interface SigningOptionsLookup extends Lookup {
  isDigital?: boolean;
  isOptOut?: boolean;
  isDownload?: boolean;
}

export type SigningOption = 'digitalSignature' | 'downAndPrintForm' | 'unableToProvideDeclaration';

export const SigningOptions: Record<SigningOption, SigningOptionsLookup> = {
  digitalSignature: {
    code: 'digitalSignature',
    displayValue: '',
    displayLabel: {
      label: 'Send email link',
    },
    isDigital: true,
  },
  downAndPrintForm: {
    code: 'downAndPrintForm',
    displayValue: '',
    displayLabel: {
      label: 'Download and complete the form',
    },
    isDownload: true,
  },
  unableToProvideDeclaration: {
    code: 'unableToProvideDeclaration',
    displayValue: '',
    displayLabel: {
      label: '',
      spousePartnerLabel: 'My <<spouseLabel>> can’t provide their Consent and Declaration',
    },
    isOptOut: true,
  },
};
